import React, {useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Title from "../dashboard/Title";
import {useDashboardStyles, BRAND} from "../settings/dashboardStyles";

const useLocalStyles = makeStyles((theme) => ({
    regionButton: {
        width: "100%",
        padding: theme.spacing(1.5, 1.75),
        background: "#ffffff",
        border: `1.5px solid ${BRAND.goldSoft}`,
        borderRadius: 10,
        color: BRAND.deep,
        fontWeight: 600,
        fontSize: "0.92rem",
        textAlign: "left",
        cursor: "pointer",
        transition: "all 180ms ease",
        fontFamily: "inherit",
        "&:hover": {
            background: BRAND.goldBg,
            borderColor: BRAND.gold,
        },
    },
    regionButtonActive: {
        background: `linear-gradient(135deg, ${BRAND.deep} 0%, ${BRAND.deepDark} 100%)`,
        color: "#ffffff",
        borderColor: BRAND.deep,
        boxShadow: "0 6px 18px rgba(44, 71, 103, 0.25)",
        "&:hover": {
            background: `linear-gradient(135deg, ${BRAND.deepDark} 0%, ${BRAND.deep} 100%)`,
            borderColor: BRAND.deepDark,
        },
    },
    viewerPaper: {
        marginTop: theme.spacing(3),
    },
    viewerTitle: {
        color: BRAND.deep,
        fontWeight: 700,
        fontSize: "1.1rem",
        marginBottom: theme.spacing(2),
    },
    iframeWrap: {
        marginTop: theme.spacing(1),
        borderRadius: 10,
        overflow: "hidden",
        border: `1px solid ${BRAND.goldSoft}`,
    },
    iframe: {
        width: "100%",
        height: "70vh",
        border: 0,
        display: "block",
        background: BRAND.creamSoft,
    },
}));

const now = new Date();
const currentYear = now.getFullYear();
const currentMonth = String(now.getMonth() + 1).padStart(2, "0");

const buildPdfUrl = (filePrefix, fileSuffix = "") =>
    `https://www.udzs-sk.sk/wp-content/uploads/${currentYear}/${currentMonth}/${filePrefix}${currentMonth}${fileSuffix}.pdf`;

const links = [
    {label: "Prešovský kraj 1", url: buildPdfUrl("Rozpis-prehliadky-mrtvych-tiel_POSK_")},
    {label: "Prešovský kraj 2", url: buildPdfUrl("Rozpis-prehliadky-mrtvych-tiel_ZASK_", "PO")},
    {label: "Košický kraj", url: buildPdfUrl("Rozpis-prehliadky-mrtvych-tiel_KESK_")},
    {label: "Banskobystrický kraj", url: buildPdfUrl("Rozpis-prehliadky-mrtvych-tiel_BBSK_")},
    {label: "Trnavský kraj", url: buildPdfUrl("Rozpis-prehliadky-mrtvych-tie_TTSK_")},
    {label: "Bratislavský kraj", url: buildPdfUrl("Rozpis-prehliadky-mrtvych-tiel_BASK_")},
    {label: "Nitriansky kraj", url: buildPdfUrl("Rozpis-prehliadky-mrtvych-tiel_NRSK_")},
    {label: "Žilinský kraj", url: buildPdfUrl("Rozpis-prehliadky-mrtvych-tiel_ZASK_", "ZA")},
    {label: "Trenčiansky kraj", url: buildPdfUrl("Rozpis-prehliadky-mrtvych-tiel_ZASK_", "TN")},
];

export default function DoctorsServices() {
    const classes = useDashboardStyles();
    const localClasses = useLocalStyles();
    const [selected, setSelected] = useState(links[0]);

    return (
        <Container maxWidth="lg" className={classes.pageContainer}>
            <Paper className={classes.paper} elevation={0}>
                <div className={classes.sectionHeader}>
                    <Title>Služby obhliadajúcich lekárov</Title>
                </div>
                <Grid container spacing={2}>
                    {links.map((item) => {
                        const active = selected?.label === item.label;
                        return (
                            <Grid item xs={12} sm={6} md={4} key={item.label}>
                                <button
                                    type="button"
                                    className={`${localClasses.regionButton} ${active ? localClasses.regionButtonActive : ''}`}
                                    onClick={() => setSelected(item)}
                                >
                                    {item.label}
                                </button>
                            </Grid>
                        );
                    })}
                </Grid>
            </Paper>

            <Paper className={`${classes.paper} ${localClasses.viewerPaper}`} elevation={0}>
                <Typography className={localClasses.viewerTitle}>
                    {selected?.label || "Zvoľte kraj"}
                </Typography>
                {selected ? (
                    <div className={localClasses.iframeWrap}>
                        <iframe
                            className={localClasses.iframe}
                            src={selected.url}
                            title={selected.label}
                        />
                    </div>
                ) : null}
            </Paper>
        </Container>
    );
}
